module.exports = __webpack_public_path__ + "static/media/tickGif.57d0b93a.gif";